import './tutorial.css';
import React from 'react';
import 'intro.js/introjs.css';
import { connect } from 'react-redux';
import { Steps } from 'intro.js-react';
import PipeJsonSteps from './pipeTutorialSteps.data.json';
import { GLOBAL_PROJECT_TYPE_CHAMBER } from '../../lib/types';
import { toggleTutorialAction, toggleConfirmationDialog, setCurrentTutorialStep } from '../../actions/tutorial-actions';
import { openAccordionSection, closeAccordionSection, closeEntireAccordion } from '../../actions/accordion-actions';
import ConfirmationDialog from './exitTutorialDialog.js';
import step1Image from '../../media/tutorial-images/Step 1-Enter_Project_Info.gif';
import step2Image from '../../media/tutorial-images/Step 2-Import_pdf.gif';
import step3Image from '../../media/tutorial-images/Step 3-Scale_and_Measure.gif';
import step4Image from '../../media/tutorial-images/Step 4-Select_Chamber_Model.gif';
import step5Image from '../../media/tutorial-images/Step 5-Storage_Length_Stone_Void.gif';
import step6Image from '../../media/tutorial-images/Step 6-Enter_System_Elevation.gif';
import step7Image from '../../media/tutorial-images/Step 7-Generate_Design.gif';
import step8Image from '../../media/tutorial-images/Step 8-Save_Current_Project.gif';
import step9Image from '../../media/tutorial-images/Step 9-Email_Drawings_&_Reports.gif';
import step10Image from '../../media/tutorial-images/Step 10-Contact_Us.gif';

class TutorialIntroContainer extends React.Component {
  stepsRef = React.createRef();
  state = {
    steps: [
      {
        element: '.projectInfoSection',
        intro: `<h3>This is where the project name and location are entered.</h3><img src='${step1Image}' style='width:23rem; height:auto'>`,
        position: 'right',
      },
      {
        element: '.backgroundAndToolsSection',
        intro: `<h3>If desired, this is where a PDF background image can be inserted.</h3><img src='${step2Image}' style='width:21rem; height:auto'>`,
        position: 'right',
      },
      {
        element: '.backgroundAndToolsSection',
        intro: `<h3>The PDF background can then be scaled and verified with the Measure Tool.</h3><img src='${step3Image}' style='width:21rem; height:auto'>`,
        position: 'right',
      },
      {
        element: '.systemParametersSection',
        intro: `<h3>Select the chamber model you would like to use for your design. If you are unsure, click on the chamber image to find additional product information.</h3><img src='${step4Image}' style='width:19rem; height:auto; max-height: 19rem;'>`,
        position: 'right',
      },
      {
        element: '.systemParametersSection',
        intro: `<h3>You can enter your design parameters here.</h3><img src='${step5Image}' style='width:19rem; height:auto; max-height: 22rem;'>`,
        position: 'right',
      },
      {
        element: '.systemParametersSection',
        intro: `<h3>The tool will automatically calculate allowable minimum and maximum finished grade elevations based on the chamber model, depth of stone and the base of stone elevation selected.</h3><img src='${step6Image}' style='width:19rem; height:auto; max-height: 18rem;'>`,
        position: 'right',
      },
      {
        element: '.systemParametersSection',
        intro: `<h3>Selecting ‘Generate Design’ will provide you with your design. Selecting ‘Reset Design’ will reset the tool and you can restart the design.</h3><img src='${step7Image}' style='width:22rem; height:auto'>`,
        position: 'right',
      },
      {
        element: '.none',
        intro: `<h3>A free account is required to use the following features.</h3>`,
        position: 'right',
      },
      {
        element: '.manageProjectsTopbar',
        intro: `<h3>You can create, save, and manage your projects here.</h3><img src='${step8Image}' style='width:22rem; height:auto'>`,
        position: 'right',
      },
      {
        element: '.emailAndPrintBlockTopbar',
        intro: `<h3>Upon completion, you can request the drawings via email drawings and reports buttons.</h3><img src='${step9Image}' style='width:22rem; height:auto'>`,
        position: 'right',
      },
      {
        element: '.contactUsSection',
        intro: `<h3>For assistance, please refer to our Contact Us information available on the tool.</h3><img src='${step10Image}' style='width:22rem; height:auto'>`,
        position: 'right',
      },
    ], // The order of the steps will affect the order the tutorial will be showed, be careful
    pipeSteps: PipeJsonSteps,
  };

  onBeforeChange = (nextStepIndex) => {
    this.props.setCurrentTutorialStep(nextStepIndex);
    const totalSteps = this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER ? this.state.steps : this.state.pipeSteps;

    // If it's the first step, hide the 'Previous' button.
    if (nextStepIndex === 0) {
      document.querySelector('.introjs-prevbutton').style.display = 'none';
    } else {
      document.querySelector('.introjs-prevbutton').style.display = 'inline-block';
    }

    // If it's the last step, hide the 'Next' button and show only the 'Done' button.
    if (nextStepIndex === totalSteps.length - 1) {
      document.querySelector('.introjs-nextbutton').style.display = 'none';
    } else {
      document.querySelector('.introjs-nextbutton').style.display = 'inline-block';
    }
  };

  closeTutorial(toggle) {
    this.props.toggleTutorialAction(toggle);
    this.props.openAccordionSection(this.props.lastOpenedAccordion);
    if (this.props.currentTutorialStep !== this.state.steps.length - 1) {
      this.props.toggleConfirmationDialog(!toggle);
    } else {
      this.props.setCurrentTutorialStep(0);
    }
  }

  handleConfirmExit = () => {
    // User confirmed to exit the tutorial
    this.props.setCurrentTutorialStep(0);
    this.props.toggleConfirmationDialog(false); // Close the dialog
  };

  handleCancelExit = () => {
    // User canceled the exit action; just close the dialog
    this.props.closeEntireAccordion();
    this.props.toggleConfirmationDialog(false);
    setTimeout(() => {
      this.props.toggleTutorialAction(true);
    }, 310);
  };

  render() {
    const { steps, pipeSteps } = this.state;

    const { projectType, toggleTutorial } = this.props;

    return (
      <React.Fragment>
        <Steps
          enabled={toggleTutorial}
          initialStep={this.props.currentTutorialStep}
          onExit={() => this.closeTutorial(false)}
          steps={projectType === GLOBAL_PROJECT_TYPE_CHAMBER ? steps : pipeSteps}
          ref={(steps) => (this.steps = steps)}
          onBeforeChange={this.onBeforeChange}
          options={{
            skipLabel: 'Close',
            showStepNumbers: false,
            exitOnOverlayClick: false,
            exitOnEsc: false,
            nextLabel: 'Next',
            prevLabel: 'Previous',
            doneLabel: 'Done',
            // Customize the skip button to call your function
          }}
        />
        <ConfirmationDialog
          isVisible={this.props.toggleTutorialConfirmationDialog}
          message="Do you really want to exit the guided tour?"
          onConfirm={this.handleConfirmExit}
          onCancel={this.handleCancelExit}
        />
        {this.props.children}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projectType: state.globals.projectType,
    toggleTutorial: state.tutorial.toggleTutorial,
    accordionStates: state.accordion.accordionStates,
    lastOpenedAccordion: state.accordion.lastOppenedSection,
    toggleTutorialConfirmationDialog: state.tutorial.toggleTutorialConfirmationDialog,
    currentTutorialStep: state.tutorial.currentTutorialStep,
  };
};

const mapDispatchToProps = {
  toggleTutorialAction,
  openAccordionSection,
  closeAccordionSection,
  toggleConfirmationDialog,
  closeEntireAccordion,
  setCurrentTutorialStep,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TutorialIntroContainer);



// WEBPACK FOOTER //
// ./src/components/Tutorial/tutorial.container.js